function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

export const GenerateCode = (length, max) => {
    var randCode = "";
    for (var i = 0; i <= length - 1; i++) {
        var num = getRandomInt(max);
        randCode += num.toString(max).toUpperCase();
    }
    
    return randCode;
}